import { NBSP } from '@r1-frontend/ui-react/tokens/symbols';

import { IAddress } from '~/src/store/reducers/auth';

export const getClientPersonalAddressStr = (address?: IAddress): string => {
    if (!address) {
        return '';
    }

    const city = address.city ? `г.${NBSP}${address.city}` : '';
    const steet = address.street ? `ул.${NBSP}${address.street}` : '';
    const house = address.house ? `д.${NBSP}${address.house}` : '';
    const flat = address.flat ? `кв.${NBSP}${address.flat}` : '';

    return `${city}, ${steet}, ${house}, ${flat}`;
};
